import { Box, Container, Grid, Typography } from '@mui/material';

const regulations = [
  { code: 'LRA', name: 'Labour Relations Act', coverage: 'Disciplinary procedures (Schedule 8), retrenchments (Section 189)', color: '#3d7aff' },
  { code: 'BCEA', name: 'Basic Conditions of Employment Act', coverage: 'Employment contracts, leave, termination (Section 42)', color: '#22c55e' },
  { code: 'EE Act', name: 'Employment Equity Act', coverage: 'EE reports (EEA2, EEA4), annual submission to DEL', color: '#c9b107' },
  { code: 'OHS Act', name: 'Occupational Health & Safety', coverage: 'Workplace injuries, Annexure 1, certification', color: '#ef4444' },
  { code: 'POPIA', name: 'Protection of Personal Information', coverage: 'Data protection, retention schedules, deletion', color: '#8b5cf6' },
  { code: 'FICA', name: 'Financial Intelligence Centre Act', coverage: 'Suspicious transaction reporting', color: '#f59e0b' },
];

export function ComplianceSection() {
  return (
    <Box sx={{ py: 14, bgcolor: '#0a0a18' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 10 }}>
          <Typography sx={{ color: '#6b7a99', fontSize: 14, fontWeight: 500, letterSpacing: '0.08em', textTransform: 'uppercase', mb: 2 }}>
            Built for South Africa
          </Typography>
          <Typography
            variant="h2"
            sx={{
              fontSize: { xs: 32, md: 48 },
              fontWeight: 700,
              letterSpacing: '-0.02em',
              color: '#f0f0f5',
              mb: 2,
            }}
          >
            Fully Compliant with SA Labour Legislation
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {regulations.map((reg) => (
            <Grid size={{ xs: 12, sm: 6, md: 4 }} key={reg.code}>
              <Box
                sx={{
                  p: 4,
                  borderRadius: 2,
                  border: '1px solid rgba(255,255,255,0.06)',
                  backgroundColor: 'rgba(18, 18, 31, 0.6)',
                  backdropFilter: 'blur(16px)',
                  height: '100%',
                  transition: 'all 0.3s ease',
                  '&:hover': { borderColor: `${reg.color}40` },
                }}
              >
                <Typography
                  sx={{
                    fontSize: 13,
                    fontWeight: 700,
                    color: reg.color,
                    letterSpacing: '0.08em',
                    textTransform: 'uppercase',
                    mb: 1,
                  }}
                >
                  {reg.code}
                </Typography>
                <Typography variant="h6" sx={{ fontWeight: 600, color: '#f0f0f5', mb: 1, fontSize: 16 }}>
                  {reg.name}
                </Typography>
                <Typography variant="body2" sx={{ color: '#a0a5b5', lineHeight: 1.5 }}>
                  {reg.coverage}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}
